import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-40ca1df0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "resolve_project" }
const _hoisted_2 = { class: "bg" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "principally main" }
const _hoisted_5 = { class: "content" }
const _hoisted_6 = { class: "left_menu" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "right_content" }
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "content" }
const _hoisted_11 = { class: "btn" }

import { ref } from "vue";
import line from "@/static/Home/resolveProject/line.png";
import ny from "@/static/Home/resolveProject/bg_img/ny.jpg";
import bx from "@/static/Home/resolveProject/bg_img/bx.jpg";
import ly from "@/static/Home/resolveProject/bg_img/ly.jpg";
import dl from "@/static/Home/resolveProject/bg_img/dl.jpg";
import whp from "@/static/Home/resolveProject/bg_img/whp.jpg";
import hk from "@/static/Home/resolveProject/bg_img/hk.jpg";
import jt from "@/static/Home/resolveProject/bg_img/jt.jpg";
import ss from "@/static/Home/resolveProject/bg_img/ss.jpg";

// import { useRouter } from "vue-router";
type scaleProps = {
  title: string;
  headline: string;
  text: string;
  path: string;
  img: string;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'resolveProject',
  setup(__props) {

const menuList = ref<scaleProps[]>();
const active_index = ref(0);

menuList.value = [
  {
    title: "农业",
    headline: "农业气象服务解决方案",
    text: "为广大农业种植大户、合作社、农业企业提供专业农业气象服务产品，实现对农事生产、农作物生长发育、农业防灾减灾、农产品质量以及产量预测等多个维度的有效帮助。",
    path: "/solution/geoponics",
    img: ny,
  },
  {
    title: "保险",
    headline: "保险服务解决方案",
    text: "为保险公司提供气象灾害风险管理服务，最大化降低气象灾害对各类保险业务造成的影响，同时研发气象风险指数产品，提升保险产品丰富度。",
    path: "/solution/insurance",
    img: bx,
  },
  {
    title: "旅游",
    headline: "旅游服务解决方案",
    text: "为旅游景区和旅游管理部门提供精细化气象服务产品和气象灾害风险预警，降低运营风险，同时为游客提供场景化气象服务产品，增强服务效果。",
    path: "/solution/tour",
    img: ly,
  },
  // {
  //   title: "电网",
  //   headline: "电网服务解决方案",
  //   text: "产品服务1的介绍产品服务1的介绍产品服务1的介绍产品服务1的介绍产品服务1的介绍产品服务1的介绍产品服务1的介绍产品服产品服务1的介绍产品服务1的介绍产品服务1的介绍产品服务1的介绍产品服务1的介绍产品服务1的介绍产品服务1的介绍产品服产品服务1的介绍产品服务1的介绍产品服务1的介绍产品服务1的介绍产品服务1的",
  //   path: "/solution/insurance",
  // },
  {
    title: "航空",
    headline: "航空服务解决方案",
    text: "气象条件对飞机的起飞、航行、降落以及其他各种飞行活动有不同的影响。飞机的设计制造和气象条件也有密切关系。航空气象服务的目的就是确保航空运输及航空运营调度的安全和效率，不利天气对飞行安全和效益产生不良的影响，这些不良影响可以通过人为努力加以避免或降低影响。",
    path: "/solution/aviation",
    img: hk,
  },
  {
    title: "交通",
    headline: "交通服务解决方案",
    text: "高速公路气象解决方案在深入挖掘高速公路领域中与气象强相关的应用场景基础上，减少恶劣天气给高速公路企业客户带来的损失，进而满足智慧交通的行业用户发展需求。",
    path: "/solution/traffic",
    img: jt,
  },
  // {
  //   title: "水文",
  //   headline: "水文服务解决方案",
  //   text: "产品服务1的介绍产品服务1的介绍产品服务1的介绍产品服务1的介绍产品服务1的介绍产品服务1的介绍产品服务1的介绍产品服产品服务1的介绍产品服务1的介绍产品服务1的介绍产品服务1的介绍产品服务1的介绍产品服务1的介绍产品服务1的介绍产品服产品服务1的介绍产品服务1的介绍产品服务1的介绍产品服务1的介绍产品服务1的",
  //   path: "/solution/insurance",
  // },
  {
    title: "体育赛事",
    headline: "体育赛事服务解决方案",
    text: "面向各类体育赛事气象服务需求，多方面、全方位提供专业化气象保障服务。",
    path: "/solution/sports",
    img: ss,
  },
  {
    title: "危化品",
    headline: "危化品服务解决方案",
    text: "对危化品储存设施及其邻近区域雷电活动进行实时监测、全面感知、临近预警。降低雷电天气对危化场所造成的伤亡、损失和社会影响。",
    path: "/solution/extreme",
    img: whp,
  },
  {
    title: "新能源气象服务",
    headline: "新能源气象服务解决方案",
    text: "构建能源气象服务体系，合理利用气象服务资源帮助企业加强新型可再生、清洁能源的开发和利用。",
    path: "/solution/energy",
    img: dl,
  },
];
const getIndex = (index: number) => {
  active_index.value = index;
};

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        src: menuList.value[active_index.value].img,
        alt: ""
      }, null, 8, _hoisted_3),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("ul", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menuList.value, (item, index) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: index,
                  class: _normalizeClass(active_index.value === index ? 'active' : ''),
                  onClick: ($event: any) => (getIndex(index))
                }, [
                  _createElementVNode("span", null, _toDisplayString(item.title), 1)
                ], 10, _hoisted_7))
              }), 128))
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("h3", null, _toDisplayString(menuList.value[active_index.value].headline), 1),
            _createElementVNode("img", {
              class: "line",
              src: _unref(line),
              alt: ""
            }, null, 8, _hoisted_9),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("li", null, _toDisplayString(menuList.value[active_index.value].text), 1)
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("span", null, [
                _createVNode(_component_router_link, {
                  to: menuList.value[active_index.value].path
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("了解更多 >>")
                  ]),
                  _: 1
                }, 8, ["to"])
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})